import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import usePaginationParams from '@hooks/usePaginationParams';
import type { OptionType } from './types';

const useGetList = () => {
  const [dispositionOptions, setDispositionOptions] = useState<OptionType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getDispositionOptions = useCallback(async ({ page = 1, limit = 10, name = '' }) => {
    setLoading(true);
    try {
      const response = await api.get('/disposition_option', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          name,
        },
      });
      setDispositionOptions(response.data.data);
      setTotalPages(response.data.total);
    } catch (error) {
      toast.error('Erro ao carregar opções de tabulação. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to load disposition options'), {
        error,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  usePaginationParams({ onParamsChange: getDispositionOptions });

  return {
    getDispositionOptions,
    dispositionOptions,
    totalPages,
    loading,
  };
};

export default useGetList;
